/** **************************************
 *               General
 *************************************** */
export var DEFAULT_MODULE_NAME = 'propera';
export var MODULE_SEPARATOR = '/';
export var DEFAULT_LOCALE = 'en_US';

/** **************************************
 *               API
 *************************************** */
export var TRAIFFIC_SHAPPING_PREFIX = 'new-';
export var FAKE_TOP_LEVEL_DOMAINS = ['.local', '.cn'];
export var TESTING_DOMAINS_PREFIX = ['test-', 'staging-', 'test2-'];